export default "<footer class=\"footer \">\n    <div class=\"container-fluid\">\n\n    </div>\n</footer>\n"